<template>
  <div>
    <transition name="slide">
      <div class="row indicador-drawer" v-if="isOpen">
        <div class="row containerIndicadores col-12">
          <div class="row col-12">
            <div class="col-11 text-center">
              <div class="title">Indicadores</div>
            </div>
            <div class="col-1 close-icon">
              <q-btn dense flat round icon="close" @click="closeComponent()" />
            </div>
          </div>
          <div class="row col-12 indicadores-item" style="display:flex;">
            <div
              class="box-container col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6"
              v-for="item in this.indicadoresData"
              v-bind:key="item.id"
            >
              <div v-if="item.tipo === 'Cualitativo' || item.tipo === 'Cuantitativo'">
                <GraficaMunicipioIndicadorAUE :dataIndicador="item" showLittleTag :tipo="item.tipo" />
              </div>
              <div v-if="item.hasOwnProperty('tarjeta')">
                <GraficaMunicipioIndicador
                v-if="!item.tarjeta.tarjetaParaObservatorio"
                :dataIndicador="item.tarjeta"
                :idRelacionAUE = "item.id"
                showLittleTag
                :datosObjetivo="datosObjetivo={datoObjetivo: item.datoObjetivo, fechaDatoObjetivo: item.fechaDatoObjetivo, unidadMedida: item.unidadMedida}"
                 />
                <GraficaMunicipioIndicador
                v-if="item.tarjeta.tarjetaParaObservatorio"
                :dataIndicador="item.tarjeta.tarjetaParaObservatorio"
                :idRelacionAUE = "item.id"
                showLittleTag
                :datosObjetivo="datosObjetivo={datoObjetivo: item.datoObjetivo, fechaDatoObjetivo: item.fechaDatoObjetivo, unidadMedida: item.unidadMedida}"
                 />
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import GraficaMunicipioIndicadorAUE from './GraficaMunicipioIndicadorAUE.vue';
import GraficaMunicipioIndicador from './GraficaMunicipioIndicador.vue';
import { mapGetters } from 'vuex';
import Loading from '@/components/shared/mixins/Loading.js';

export default {
  components: {
    GraficaMunicipioIndicadorAUE,
    GraficaMunicipioIndicador
  },
  mixins: [Loading],
  computed: {
    ...mapGetters({
      ciudadSelected: 'NGUD/ciudadData'
    })
  },
  props: {
    value: {
      required: true
    },
    indicadores: Array
  },
  data () {
    return {
      isOpen: false,
      indicadoresData: []
    };
  },
  created () {
    this.indicadoresData = this.indicadores;
  },
  methods: {
    closeComponent () {
      this.isOpen = false;
      this.$emit('input', this.isOpen);
      this.$emit('close');
    }
  },
  watch: {
    value (newValue) {
      this.isOpen = newValue;
    },
    indicadores () {
      this.indicadoresData = this.indicadores;
    }
  }
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  color: inherit;
}
.box-container {
  padding: 10px;
}
.slide-leave-active {
  transition: 1s;
}
.slide-enter-active {
  transition: 1s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(120%, 0);
}

.slide-right {
  -webkit-transition: width 1s ease-in-out;
  -moz-transition: width 1s ease-in-out;
  -o-transition: width 1s ease-in-out;
  transition: width 1s ease-in-out;
}
.indicador-drawer {
  // TEMP DEV
  // border: 1px solid;
  // background: white;
  z-index: 9999;
  display: flex;
  left: 0;
  right: 0;
  .containerIndicadores {
    display: flex;
    flex-direction: row;
    .title {
      display: flex;
      justify-content: center;
      font-family: DINPro;
      font-size: 30px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: -1.21px;
      color: #002f6c;
    }
    .subtitle {
      display: flex;
      justify-content: center;
      font-size: 16px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: -0.64px;
      color: #252626;
    }

    .indicadores-item {
      padding-top: 40px;
    }
  }
}
</style>
